import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    // redirect: 'https://www.baidu.com',
    name: 'Menu',
    meta: {
      title: '目录'
    },

    component: () => import(/* webpackChunkName: "Menu" */ '../views/menu.vue')
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      title: '登录'
    },

    component: () => import(/* webpackChunkName: "Login" */ '../views/Login.vue')
  },
  {
    path: '/signin',
    name: 'Signin',
    meta: {
      title: '注册'
    },

    component: () => import(/* webpackChunkName: "Signin" */ '../views/Signin.vue')
  },
  {
    path: '/password',
    name: 'Password',
    meta: {
      title: '忘记密码'
    },

    component: () => import(/* webpackChunkName: "Password" */ '../views/Password.vue')
  },
  {
    path: '/password1',
    name: 'Password1',
    meta: {
      title: '忘记密码'
    },

    component: () => import(/* webpackChunkName: "Password" */ '../views/Password1.vue')
  },
]

const supplierRoutes = [
  {
    path: '/home-supplier',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '../views/suppliercenter/HomeView.vue')
  },
  {
    path: '/suppliercenter-information',
    name: 'suppliercenterinformation',
    component: () => import(/* webpackChunkName: "about" */ '../views/suppliercenter/Information.vue')
  },
  {
    path: '/info-password',
    name: 'password',
    component: () => import(/* webpackChunkName: "about" */ '../views/suppliercenter/Password.vue')
  },
  {
    path: '/info-qualifications',
    name: 'qualifications',
    component: () => import(/* webpackChunkName: "about" */ '../views/suppliercenter/Qualifications.vue')
  },
  {
    path: '/supplier-equity',
    name: 'equity',
    component: () => import(/* webpackChunkName: "about" */ '../views/suppliercenter/Equity.vue')
  },
  // 0606
  {
    path: '/download-center',
    name: 'download',
    component: () => import(/* webpackChunkName: "about" */ '../views/suppliercenter/download.vue')
  },
  {
    path: '/task-center',
    name: 'task',
    component: () => import(/* webpackChunkName: "about" */ '../views/suppliercenter/task.vue')
  },
  {
    path: '/order-list',
    name: 'order',
    component: () => import(/* webpackChunkName: "about" */ '../views/suppliercenter/order.vue')
  },
  {
    path: '/info-recharge',
    name: 'recharge',
    component: () => import(/* webpackChunkName: "about" */ '../views/suppliercenter/Recharge.vue')
  },
  {
    path: '/info-record',
    name: 'record',
    component: () => import(/* webpackChunkName: "about" */ '../views/suppliercenter/Record.vue')
  },
  {
    path: '/suppliercenter-onlinebook',
    name: 'onlinebook',
    component: () => import(/* webpackChunkName: "about" */ '../views/suppliercenter/Onlinebook.vue')
  },
  {
    path: '/suppliercenter-bookmanagement',
    name: 'bookmanagement',
    component: () => import(/* webpackChunkName: "about" */ '../views/suppliercenter/Bookmanagement.vue')
  },
  {
    path: '/suppliercenter-library',
    name: 'library',
    component: () => import(/* webpackChunkName: "about" */ '../views/suppliercenter/Library.vue')
  },
  {
    path: '/suppliercenter-uploadlibrary',
    name: 'uploadlibrary',
    component: () => import(/* webpackChunkName: "about" */ '../views/suppliercenter/Uploadlibrary.vue')
  },
  {
    path: '/suppliercenter-submittedorder',
    name: 'submittedorder',
    component: () => import(/* webpackChunkName: "about" */ '../views/suppliercenter/Submittedorder.vue')
  },
  {
    path: '/common-myattention',
    name: 'myattention',
    component: () => import(/* webpackChunkName: "about" */ '../views/common/MyAttention.vue')
  },
  {
    path: '/common-myfans',
    name: 'myfans',
    component: () => import(/* webpackChunkName: "about" */ '../views/common/MyFans.vue')
  },
  {
    path: '/common-messagecenter',
    name: 'messagecenter',
    component: () => import(/* webpackChunkName: "about" */ '../views/common/MessageCenter.vue')
  },
]

const memberRoutes = [
  {
    path: '/membercenter-projectmanagement',
    name: 'projectmanagement',
    component: () => import(/* webpackChunkName: "about" */ '../views/membercenter/Projectmanagement.vue')
  },
  {
    path: '/membercenter-mycollection',
    name: 'mycollection',
    component: () => import(/* webpackChunkName: "about" */ '../views/membercenter/Mycollection.vue')
  },
  {
    path: '/membercenter-myorder',
    name: 'myorder',
    component: () => import(/* webpackChunkName: "about" */ '../views/membercenter/Myorder.vue')
  },
  {
    path: '/membercenter-submittedorder',
    name: 'submittedorder',
    component: () => import(/* webpackChunkName: "about" */ '../views/membercenter/Submittedorder.vue')
  },
  {
    path: '/common-myattention',
    name: 'myattention',
    component: () => import(/* webpackChunkName: "about" */ '../views/common/MyAttention.vue')
  },
  {
    path: '/common-myfans',
    name: 'myfans',
    component: () => import(/* webpackChunkName: "about" */ '../views/common/MyFans.vue')
  },
  {
    path: '/common-messagecenter',
    name: 'messagecenter',
    component: () => import(/* webpackChunkName: "about" */ '../views/common/MessageCenter.vue')
  },
  {
    path: '/home-center',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '../views/membercenter/HomeView.vue')
  },
  {
    path: '/info-center',
    name: 'information',
    component: () => import(/* webpackChunkName: "about" */ '../views/membercenter/Information.vue')
  },
  {
    path: '/center-password',
    name: 'password',
    component: () => import(/* webpackChunkName: "about" */ '../views/membercenter/Password.vue')
  },
  {
    path: '/center-qualifications',
    name: 'qualifications',
    component: () => import(/* webpackChunkName: "about" */ '../views/membercenter/Qualifications.vue')
  },
  {
    path: '/center-equity',
    name: 'equity',
    component: () => import(/* webpackChunkName: "about" */ '../views/membercenter/Equity.vue')
  },
  {
    path: '/center-recharge',
    name: 'recharge',
    component: () => import(/* webpackChunkName: "about" */ '../views/membercenter/Recharge.vue')
  },
  {
    path: '/center-record',
    name: 'record',
    component: () => import(/* webpackChunkName: "about" */ '../views/membercenter/Record.vue')
  },
  {
    path: '/member-download-center',
    name: 'download',
    component: () => import(/* webpackChunkName: "about" */ '../views/membercenter/download.vue')
  },
  {
    path: '/member-task-center',
    name: 'task',
    component: () => import(/* webpackChunkName: "about" */ '../views/membercenter/task.vue')
  },
  {
    path: '/member-search-center',
    name: 'task',
    component: () => import(/* webpackChunkName: "about" */ '../views/membercenter/search.vue')
  },
]

const createRouter = () => new VueRouter({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: routes
})
const router = createRouter()

export default router

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export { routes, supplierRoutes, memberRoutes }
